import React from "react";
import { ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { STOREFRONT_IMAGE } from "../../lib/home-content";

const AboutSection = () => (
  <section
    id="about"
    className="relative scroll-mt-24 text-white overflow-hidden"
    style={{
      background:
        "linear-gradient(180deg, #0F1245 0%, #161a5e 35%, #2a2e7f 70%, #4A3FCF 100%)",
    }}
  >
    {/* Soft aura accents to give the gradient depth */}
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          "radial-gradient(circle at 80% 10%, rgba(183,228,244,0.10) 0%, transparent 45%), radial-gradient(circle at 0% 90%, rgba(74,63,207,0.25) 0%, transparent 55%)",
      }}
      aria-hidden="true"
    />
    <div className="absolute inset-0 grain opacity-[0.6] pointer-events-none" aria-hidden="true" />

    <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <Reveal className="lg:col-span-5">
        <div className="aspect-[4/5] relative overflow-hidden grain border border-white/10 shadow-2xl shadow-black/30">
          <img
            src={STOREFRONT_IMAGE}
            alt="Style India Delhi storefront and showroom interior — Lajpat Nagar IV"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "center top" }}
            loading="lazy"
          />
        </div>
      </Reveal>
      <Reveal className="lg:col-span-7 lg:pl-6" delay={150}>
        <div className="overline" style={{ color: "#B7E4F4" }}>About Us</div>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light mt-4 leading-[1.05] text-white">
          Our <span className="italic text-[#B7E4F4]">wholesale journey.</span>
        </h2>
        <p className="mt-8 text-[16px] text-white/75 leading-relaxed">
          Style India Delhi began in <strong className="text-white font-medium">2007</strong> on the wholesale lanes of Lajpat Nagar, New Delhi. Eighteen years on, we&apos;ve grown into one of India&apos;s most-trusted manufacturers and wholesalers of <strong className="text-white font-medium">designer ladies ethnic wear</strong> — supplying suits, co-ord sets, kaftans, kurta sets and party-wear to over <strong className="text-white font-medium">20,000 retailers</strong>.
        </p>
        <p className="mt-5 text-[16px] text-white/75 leading-relaxed">
          Every piece you see is <strong className="text-white font-medium">designed and manufactured in our own facility</strong> — no third-party suppliers, no fabric compromises. Our in-house design team adds <strong className="text-white font-medium">trend-forward collections every week</strong>, so boutiques and online sellers always have something fresh to stock.
        </p>
        <p className="mt-5 text-[16px] text-white/75 leading-relaxed">
          We pride ourselves on <strong className="text-white font-medium">premium quality, unwavering customer support and worldwide shipping</strong> — backed by 18 years of operational discipline. From a single video appointment to a 600-piece overseas dispatch, you get the same dedicated team every time.
        </p>

        <div className="mt-10">
          <a href="/#contact" className="inline-flex items-center gap-3 text-[12px] tracking-[0.22em] uppercase font-medium text-white hover:text-[#B7E4F4] transition-colors">
            Talk to our wholesale desk <ArrowRight size={14} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default AboutSection;
